var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4927 110.001H6.87988C6.87988 105.257 11.4991 101.4 17.1863 101.4C22.8736 101.4 27.4927 105.257 27.4927 110.001Z",
    fill: "#3E4347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.12 110.001H82.4932C82.4932 105.257 87.1123 101.4 92.7996 101.4C98.5007 101.4 103.12 105.257 103.12 110.001Z",
    fill: "#3E4347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7119 1.96786L30.4951 3.18359L59.6531 32.3663L60.8698 31.1506L31.7119 1.96786Z",
    fill: "#3E4347"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0859 0C32.5147 0 33.666 1.15132 33.666 2.58008C33.666 4.00883 32.5147 5.16015 31.0859 5.16015C29.6572 5.16015 28.5059 4.00883 28.5059 2.58008C28.5059 1.15132 29.6572 0 31.0859 0Z",
    fill: "#3E4347"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2932 1.96617L49.127 31.1406L50.3434 32.3567L79.5096 3.18225L78.2932 1.96617Z",
    fill: "#3E4347"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9141 0C80.3428 0 81.4941 1.15132 81.4941 2.58008C81.4941 4.00883 80.3428 5.16015 78.9141 5.16015C77.4853 5.16015 76.334 4.00883 76.334 2.58008C76.334 1.15132 77.4853 0 78.9141 0Z",
    fill: "#3E4347"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0001 15.4668C63.0733 15.4668 69.6067 19.3092 69.6067 24.0671C69.6067 28.8249 63.0733 32.6673 55.0001 32.6673C46.927 32.6673 40.3936 28.8249 40.3936 24.0671C40.3936 19.3092 46.927 15.4668 55.0001 15.4668Z",
    fill: "#3E4347"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.687 101.095C95.2131 113.121 17.6999 112.802 6.28373 101.095C-2.09458 92.4945 -2.09458 41.5727 6.28373 32.9586C17.686 21.2512 95.2131 20.9182 104.687 32.9586C111.762 41.9611 111.776 92.0923 104.687 101.095Z",
    fill: "#B291C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.112 92.9097C80.0099 102.065 21.8611 101.815 13.3163 92.9097C7.03258 86.3763 7.03258 47.6751 13.3163 41.1279C21.875 32.2363 80.0099 31.9866 87.112 41.1279C92.4248 47.9664 92.4248 86.085 87.112 92.9097Z",
    fill: "#3E4347"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6797 44.6797C102.523 44.6797 104.84 46.9823 104.84 49.8398C104.84 52.6973 102.537 55 99.6797 55C96.8361 55 94.5195 52.6973 94.5195 49.8398C94.5195 46.9823 96.8361 44.6797 99.6797 44.6797Z",
    fill: "#3E4347"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6797 60.1465C102.523 60.1465 104.84 62.4491 104.84 65.3066C104.84 68.1503 102.537 70.4668 99.6797 70.4668C96.8361 70.4668 94.5195 68.1641 94.5195 65.3066C94.5334 62.463 96.8361 60.1465 99.6797 60.1465Z",
    fill: "#3E4347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigTv);
export default __webpack_public_path__ + "static/media/big-tv.5bacb518b0bbf9c8f5e809d7a961a8e0.svg";
export { ForwardRef as ReactComponent };